import axios from "axios";
// config
import { HOST_API } from "src/config-global";

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (
            error.request.responseType === "blob" &&
            error.response.data instanceof Blob &&
            error.response.data.type.toLowerCase().includes("json")
        ) {
            const blobError = JSON.parse(await error.response.data.text());
            //
            return Promise.reject(blobError || "Something went wrong！");
        }
        return Promise.reject(error.response?.data || "Something went wrong");
    }
);

export default axiosInstance;

export const API_ENDPOINTS = {
    settings: {
        accountInfo: "/settings/account/info",
        avatar: "/settings/account/avatar/update",
        updateAccount: `/web/profile/update`,
        resetPassword: `/web/profile/reset_password`
    },
    api: {
        keysList: "/client/query_client",
        deleteKey: "/client/delete_client",
        registerKey: "/client/register_client"
    },
    automation: {
        getPrinter: "/automation/config/printer_setting/get",
        savePrinter: "/automation/config/printer_setting/save",
        getInsurance: "/automation/config/insurance_setting/get",
        saveInsurance: "/automation/config/insurance_setting/save",
        getInternational: "/automation/config/international_setting/get",
        saveInternational: "/automation/config/international_setting/save",
        getLabelPrint: "/automation/config/label_print_option/get",
        saveLabelPrint: "/automation/config/label_print_option/save",
        getOrderGetRateMode: "/automation/config/order_get_rate_view_setting/get",
        saveOrderGetRateMode: "/automation/config/order_get_rate_view_setting/save"
    },
    address: {
        autocomplete: "/address/automation",
        autocompleteSelectOption: "/address/details",
        //
        verifyAddress: "/address/validate",
        //
        addAddressBooks: "/address/create",
        deleteAddressBooks: "/address/delete",
        editAddressBooks: "/address/edit",
        getAddressBooks: "/address/query",
        markAsDefault: "/address/mark_as_default"
    },
    notifications: {
        getNotifications: "/notification/page",
        markRead: "/notification/mark_read",
        markReadAll: "/notification/mark_read_all"
    },
    tasks: {
        getTasks: "/task_manager/query_by_page",
        queryById: "/task_manager/query_by_ids",
        //
        info: "/task/info",
        query: "/task/query",
        exportProduct: "/task/export_product",
        exportBin: "/task/export_bin",
        exportInventory: "/task/export_transfer",
        exportInventoryHistory: "/task/export_history",
        importBin: "/task/import_bin",
        importProduct: "/task/import_product",
        importNewInventory: "/task/import_new_inventory",
        importFullInventory: "/task/import_full_inventory",
        exportRebate: "/task/export_rebate",
        exportTransaction: "/task/export_transaction",
        importShippingRule: "/task/import_shipping_rules",
        exportShippingRule: "/task/export_shippingRules",
        clearUnRead: "/task/clear_tasks",
        clearAll: "/task/clear_tasks_all",
        importOrder: "/task/import_orders",
        exportOrder: "/task/export_order"
    },
    user: {
        checkGuide: "/user_guide/progress",
        updateGuide: "/user_guide/update_progress"
    },
    plan: {
        getList: "/fee/plan/list",
        bind: "/fee/plan/bind",
        bindSpecial: "/fee/plan/bind_special",
        update: "/fee/plan/change",
        getDetail: "/fee/plan/detail",
        hasTrial: "/fee/plan/has_trialed",
        repay: "/fee/plan/repay",
        checkCreateAvailable: "/fee/plan/can_create_label",
        checkHasPayFailed: "fee/plan/has_pay_failed_plan",
        checkIsProCustomer: "/fee/plan/is_pro_customer"
    },
    shippingRules: {
        searchShippingRules: "/shipping_rule/query_all",
        createShippingRules: "/shipping_rule/create",
        editShippingRules: "/shipping_rule/edit",
        updateStatus: "/shipping_rule/update_status",
        deleteShippingRules: "/shipping_rule/delete",
        updatePriority: "/shipping_rule/update_priority",
        runShippingRule: "/shipping_rule/run",
        applyRule: "/shipping_rule/apply_rule"
    },
    packages: {
        searchAllPackages: "/package/query",
        createPackage: "/package/create",
        editPackage: "/package/edit",
        deletePackage: "/package/delete",
        makeDefault: "/package/mark_as_default",
        searchPredefinedPackages: "/package/query_predefined_packages",
        getDimensionUnit: `/automation/config/packages_setting/get`,
        editDimensionUnit: "/automation/config/packages_setting/save"
    },
    orders: {
        getOrders: "/order/search_orders",
        getSubOrders: "/order/sub_orders",
        changeToAwaiting: "/order/change_to_awaiting",
        changeToCancel: "/order/change_to_cancel",
        changeToShipped: "/order/change_to_shipped",
        deleteOrder: "/order/delete",
        importOrder: "/order/import",
        getPackingSlip: "/order/download_packing_slip",
        getPackingSlips: "/order/batch_download_packing_slip",
        splitOrder: "/order/split_order",
        splitOrderRevert: "/order/revert_split_order",
        getAllCombine: "/order/list_combine_candidate",
        combineOrder: "/order/combine_order",
        combineOrderRevert: "/order/revert_combine_order",
        getOrderDetail: "/order/order_detail",
        syncOrder: "/order/sync",
        updateOrderPackage: "/order/edit_order_package",
        buyLabel: "/order/buy_label_from_order",
        printLabel: "/order/print_label",
        sendTrackingEmail: "/order/notify/send",
        getCustomPrint: "order/custom_print",
        //
        getPreSignedURL: "/order/order_import_pre_signed_url",
        importOrderV2: "/order/import/v2",
        createOrder: "/order/create_onsite",
        //
        scanOrder: "/order/scan",
        getRate: "/rate/list",
        buyRate: "/rate/buy",
        //
        getTagList: "/order/tag/query_tags",
        createTagList: "/order/tag/create",
        addTag: "/order/add_tags",
        removeTag: "/order/remove_tags"
    }
};
